var inputRestrictions = {
    tel: /^[0-9]*$/g,
};
var inputSanitizers = {
    tel: /[^0-9]/g,
};

export { inputRestrictions, inputSanitizers };
